// extracted by mini-css-extract-plugin
export default {"add-review__form":"AddReview_add-review__form__g04hY","add-review__input":"AddReview_add-review__input__6IuvU","add-review__submit":"AddReview_add-review__submit__ehGgT"};